// Opens a print-ready window with AfriGate-branded styling and auto-prints.
export function printHtml(title, innerHtml) {
  const w = window.open("", "_blank", "width=860,height=940");
  if (!w) return;
  w.document.write(`<!doctype html><html><head><title>${title}</title>
    <style>
      body{font-family:'Outfit',Helvetica,Arial,sans-serif;color:#111;padding:28px}
      .brand{font-size:12px;letter-spacing:.25em;text-transform:uppercase;color:#306D29;margin-bottom:6px}
      h1{color:#0D530E;font-size:24px;margin:0 0 2px}
      .sub{color:#666;margin:0 0 18px;font-size:13px}
      table{width:100%;border-collapse:collapse;font-size:13px;margin-bottom:14px}
      th,td{border:1px solid #ddd;padding:8px 10px;text-align:left;vertical-align:top}
      th{background:#f3f0e0;color:#0D530E}
      .chk{width:22px;height:22px;border:2px solid #333;display:inline-block;border-radius:4px}
      .grp{margin:20px 0 6px;font-weight:700;color:#0D530E;font-size:15px}
      @media print{@page{margin:12mm}}
    </style></head>
    <body>
      <div class="brand">AfriGate Fulfilment</div>
      ${innerHtml}
      <script>window.onload=function(){setTimeout(function(){window.print();},200);}<\/script>
    </body></html>`);
  w.document.close();
}

const esc = (s) => String(s == null ? "" : s).replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]));

export function pickSheetHtml(order) {
  const rows = (order.items || []).map((it) => `<tr>
    <td><span class="chk"></span></td>
    <td>${esc(it.name)}</td>
    <td>${esc(it.quantity)}</td>
    <td>${esc(it.source_store || "")}</td>
    <td>${esc(it.category || "")}</td>
    <td>${esc(it.note || "")}</td></tr>`).join("");
  return `<h1>Pick sheet — ${esc(order.order_number)}</h1>
    <p class="sub">${esc(order.customer?.name || order.customer_name || "")} · ${esc(order.customer?.city || order.city || "")}</p>
    <table><thead><tr><th></th><th>Item</th><th>Qty</th><th>Store</th><th>Category</th><th>Note</th></tr></thead>
    <tbody>${rows}</tbody></table>`;
}

export function wavePickSheetHtml(wave, orders) {
  const groups = (orders || []).map((o) => {
    const rows = (o.items || []).map((it) => `<tr>
      <td><span class="chk"></span></td>
      <td>${esc(it.name)}</td><td>${esc(it.quantity)}</td>
      <td>${esc(it.source_store || "")}</td><td>${esc(it.note || "")}</td></tr>`).join("");
    return `<div class="grp">${esc(o.order_number)} · ${esc(o.customer_name || "")} · ${esc(o.city || "")}</div>
      <table><thead><tr><th></th><th>Item</th><th>Qty</th><th>Store</th><th>Note</th></tr></thead>
      <tbody>${rows}</tbody></table>`;
  }).join("");
  return `<h1>Pick wave — ${esc(wave.wave_number)}</h1>
    <p class="sub">${esc(wave.grouping || "mixed")} · ${(orders || []).length} orders · picker: ${esc(wave.assigned_to || "unassigned")}</p>
    ${groups}`;
}

export function manifestHtml(container) {
  const rows = (container.orders_detail || []).map((o) => `<tr>
    <td>${esc(o.order_number)}</td><td>${esc(o.customer_name || "")}</td>
    <td>${esc(o.city || "")}</td><td>${esc((o.packages || []).join(", "))}</td></tr>`).join("");
  return `<h1>Container manifest — ${esc(container.container_number)}</h1>
    <p class="sub">${esc(container.route || "")} · ${container.total_orders} orders · ${container.total_packages} packages · ${esc(container.manifest_status || "")}</p>
    <table><thead><tr><th>Order</th><th>Customer</th><th>Zone / City</th><th>Packages</th></tr></thead>
    <tbody>${rows}</tbody></table>`;
}
